import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_LONG_TERM_NEW_ITEM_FOR_LONG_TERM_STAY_QUERY = graphql(/* GraphQL */ `
	query discountLongTermNewItemForLongTermStay($hotelID: String!, $duplicateDiscountId: ID) {
		discountLongTermNewItem(hotelID: $hotelID, duplicateDiscountID: $duplicateDiscountId) {
			name
			hotelID
			discountID
			discountCode
			inSale
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			resourceLowestPrice {
				currencyType
				amount
			}
			discountPriceTotalLimit {
				currencyType
				amount
			}
			longTermStayDiscountObject {
				includeSmallestNights
				discountType
				ratio
				staticTargetType
				static {
					currencyType
					amount
				}
			}
		}
	}
`);
